import { React, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";

import "./IndividualStudentResultsOverview.css";
import "./ClassOverview.css";

import ReturnToClassResults from "./RetrunToClassResults";
import AllReportCardsHistory from "./AllReportCardsHistory";
import GradeCard from "./GradeCard";
import PrintAllStudentResults from "./PrintAllStudentResults";
import PrintAllStudentReportCards from "./PrintAllStudentReportCards";
import RecommendationsButton from "./RecommendationsButton";

function AllStudentReportCardsOverview(props) {
  const {
    classDetails,
    studentResults,
    assessmentResultsByStudent,
    schoolid,
    teacherid,
    classAssessments,
    teachers,
    assessment,
    students,
  } = props;

  const {
    grade_level1: gradeLevel1,
    grade_level2: gradeLevel2,
    grade_level3: gradeLevel3,
    trial_class: trialClass,
  } = classDetails;

  const [toggleScoreType, setToggleScoreType] = useState("");

  return (
    <div className="class-overview-container">
      <Container className="container-shape">
        <Row className="page-description-bar">
          <Col className="col-6">
            <Row>
              <Col className="col-6">
                <h2 className="page-description-header">{classDetails.name}</h2>
              </Col>
              <Col className="col-4">
                <GradeCard
                  gradeLevel={props.gradeLevel}
                  gradeLevel1={classDetails.grade_level1}
                  gradeLevel2={classDetails.grade_level2}
                  gradeLevel3={classDetails.grade_level3}
                  trialClass={classDetails.trial_class}
                />
              </Col>
            </Row>
            <p>
              Individual Student Report Cards for a particular assessment point.
              Click Print Report Cards to get a print view of each indiv
              student's report card.
            </p>
          </Col>
          <Col className="col-4">
            <Row>
              <Col className="col-3"></Col>
              <Col className="col-3">
                <ReturnToClassResults
                  classDetails={classDetails}
                  teachers={teachers}
                  classAssessments={classAssessments}
                  assessment={assessment}
                  schoolid={schoolid}
                  teacherid={teacherid}
                />
              </Col>
              <Col className="col-1"></Col>
              {/* <Col className="col-4">
                <RecommendationsButton onResultsPage={true} />
              </Col> */}
            </Row>
          </Col>
        </Row>

        <hr />

        <Row>
          <Col className="col-3">
            <PrintAllStudentReportCards
              studentResults={studentResults} // Pass the student results
              toggleScoreType={toggleScoreType}
              assessmentResultsByStudent={assessmentResultsByStudent}
              isPrintOut={true}
              detailedView={true}
              teacherid={teacherid}
              schoolid={schoolid}
              teachers={teachers}
              students={students} // Pass the students here
              buttonName={"Print Detailed"}
              classDetails={classDetails}
            />
          </Col>
        </Row>

        <AllReportCardsHistory
          studentResults={studentResults} // Pass the student results
          toggleScoreType={toggleScoreType}
          assessmentResultsByStudent={assessmentResultsByStudent}
          isPrintOut={false}
          detailedView={true}
          teacherid={teacherid}
          schoolid={schoolid}
          teachers={teachers}
          students={students}
        />
      </Container>
    </div>
  );
}

export default AllStudentReportCardsOverview;
